export default __webpack_public_path__ + "static/blockchain-56a42b3a851e370afc3e74d464fbe6d4.png";